import actionsMutations from "./mutations.js";
import actionsActions from "./actions.js";
import actionsGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            actions: {},
            pasteActionsinfo: null,
            newUpdates:[]
        };
    },
    mutations: actionsMutations,
    actions: actionsActions,
    getters: actionsGetters,
};